import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class EmailTemplateList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading} = this.props;
        if (!filter) {
            filter = [];
        }
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "EmailTemplateList"}
                {...props}
                columns={ {
                    id: {header: 'Kód', width: 2, sortable},
                    token: {header: 'Token', width: 2, sortable},
                    subject: {header: 'Tárgy', width: 6, filterable, sortable},
                    type: {header: 'Típus', width: 2, filterable, sortable}
                } }
                filter={[{
                    field: "type",
                    operator: "!=",
                    value: "mail"
                }, ...filter]}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default EmailTemplateList;
